module.exports = __webpack_public_path__ + "static/media/COS_LUXEOL_NUTRAVALIA.96156c9b.png";